import React from 'react'
import { ApiHook } from '../../hooks/apiHook'
import { useTranslation } from 'react-i18next'
import { Button, Card } from 'react-bootstrap'
import { formatDateWithoutTime } from '../../utils/formateDate'
import { convertTo12HourFormat } from '../../utils/convertTimeFormat'
import { toast } from 'react-toastify'

export default function SponsorMeetings() {
    const { t } = useTranslation()
    const { data } = ApiHook.CallSponsorMeetings()
    const copyToClipboard = async (text) => {
        if (navigator && navigator.clipboard) {
            try {
                await navigator.clipboard.writeText(text);
                toast.success("Link Copied")
            } catch (error) {
                console.error("Clipboard copy failed:", error);
            }
        } else {
            // Clipboard API is not supported, provide a fallback method
            try {
                const textArea = document.createElement("textarea");
                textArea.value = text;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand("copy");
                document.body.removeChild(textArea);
                toast.success("Link Copied")
            } catch (error) {
                console.error("Fallback clipboard copy failed:", error);
            }
        }
    };
    const openLink = (link) => {
        window.open(link, "_blank");
    }
    return (
        <>
            <div className="page_head_top">{t("meetings")}</div>
            <div className="ewallet_top_btn_sec">
                <div className="row gap-5 d-flex">

                    {data?.length==0?
                    <>
                    <div className="nodata-table-view">
                  <div className="nodata-table-view-box">
                    <div className="nodata-table-view-box-img">
                      <img src="/images/no-data-image1.jpg" alt="" />
                    </div>
                    <div className="nodata-table-view-box-txt">
                      {t("sorry_no_data_found")}
                    </div>
                  </div>
                </div>
                    </>
                    :data?.map((e) => (
                        <>
                            <Card className='meeting_card' style={{ width: "25rem" }}>
                                <Card.Img className='meeting_card_img' variant="top" src={"/images/meeting.jpg"} />
                                <Card.Body>
                                    <Card.Title>{(e.title).toUpperCase()}</Card.Title>
                                    <Card.Subtitle className='meeting-subtitle'>{`${formatDateWithoutTime(e.date)} ${convertTo12HourFormat(e.startTime)} ${e.endTime ? ` to ${convertTo12HourFormat(e.endTime)}` : ""}`}</Card.Subtitle>

                                    <Card.Text style={{ height: "100px", overflow: "auto" }}>
                                        {
                                            e.description
                                        }
                                    </Card.Text>
                                    <div className='text-center d-flex gap-2'>
                                        <input type="text" value={e.link} className='form-control' />
                                        {/* <Button variant="primary" onClick={() => copyToClipboard(e.link)}>{t('Copy')}</Button> */}
                                        <Button variant="primary" onClick={() => openLink(e.link)}>{t('Open')}</Button>
                                    
                                    </div>
                                </Card.Body>
                            </Card>
                        </>
                    ))

                    }
                </div>
            </div>
        </>
    )
}
